import script from "./pickStorePlural.vue?vue&type=script&setup=true&lang=js"
export * from "./pickStorePlural.vue?vue&type=script&setup=true&lang=js"

import "./pickStorePlural.vue?vue&type=style&index=0&id=65d4ebdc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65d4ebdc"]])

export default __exports__